import { render } from "./BlankLayout.vue?vue&type=template&id=01f71f96&ts=true"
import script from "./BlankLayout.vue?vue&type=script&lang=ts"
export * from "./BlankLayout.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__